import { BaseError } from "@silo/types";

export class ContractsClientError extends BaseError {
  public readonly _tag = "ContractsClientError";
}
